<template>
  <div class="footer">
    <p id="school">Powered by 中国工程科技研究机构与专家库</p>
    <div class="content">
      <div class="floatlft">©2012&nbsp;CKCEST&nbsp;ICP备案号:京ICP备14021735号-2</div>
      <div class="floatrig">
        <a href="http://www.ckcest.cn/default/legalNotices">法律声明</a>
        <span class="split">&nbsp;|&nbsp;</span>
        <a @click="show">联系我们</a>
        <span class="split">&nbsp;|&nbsp;</span>
        <a href="http://expert.ckcest.cn/state">数据说明</a>
         <span class="split">&nbsp;|&nbsp;</span>
        <router-link :to="{path:'help'}">帮助中心</router-link>
        <span class="split">&nbsp;|&nbsp;</span>
        <a href="http://www.ckcest.cn/aboutUs/Subcenter1">关于我们</a>
        <span class="split">&nbsp;|&nbsp;</span>
        <router-link :to="{path:'Us'}">团队介绍</router-link>
      </div>
      <div class="clear"></div>
    </div>
    <el-dialog title="联系我们" :visible.sync="dialogFormVisible"  :before-close="out">
      <el-form :model="form" :rules="rules" ref="form" :label-width="formLabelWidth">
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名"  prop="name">
              <el-input v-model="form.name" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱"  prop="email">
              <el-input v-model="form.email" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="留言"  prop="msg">
              <el-input v-model="form.msg" autocomplete="off" type="textarea" :rows="8"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="验证码"  prop="code">
          <el-row>
            <el-col :span="6" style="margin-right:20px">
              <el-input placeholder="请输入图片验证码" size="large" v-model="form.code"></el-input>
            </el-col>
            <el-col :span="6">
              <img :src="srcUrl" height="40px" @click="updateCode()" v-if="reWrite" />
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="out">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="loading" style=" background: #75867c;">发送留言</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { getMsg } from '@/api/common'

export default {
  name: 'Footer',
  data () {
    return {
      form: {
        name: '',
        email: '',
        msg: '',
        code: ''
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        msg: [{ required: true, message: '请输入留言', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      formLabelWidth: '100px',
      srcUrl: 'http://expert.ckcest.cn/verity_code',
      reWrite: true,
      loading: false
    }
  },
  computed: {
    dialogFormVisible () {
      return this.$store.state.ContactUs
    }
  },
  methods: {
    updateCode () {
      this.reWrite = false
      this.$nextTick(function () {
        this.reWrite = true
      })
    },
    show () {
      this.$store.commit('ContactUs', true)
    },
    out () {
      this.$store.commit('ContactUs', false)
    },
    submitForm (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.loading = true
          let data = {
            code: this.form.code,
            name: this.form.name,
            email: this.form.email,
            body: this.form.msg
          }
          getMsg(data)
            .then(res => {
              this.loading = false
              if (res.status === 1) {
                this.$refs[form].resetFields()
                this.$message({
                  message: '您的留言信息已发给管理员，非常感谢！',
                  offset: '200'
                })
              }
              this.$store.commit('ContactUs', false)
            })
            .catch(err => {
              console.log(err)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  },
  mounted () {

  }
}
</script>
<style scoped>
#school {
  background-color: #505050;
  height: 150px;
  line-height: 150px;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  margin-bottom: 0;
}
.content {
  padding: 0 10vw;
  line-height: 50px;
  color: #eaeaea;
  height: 50px;
  background-color: #242526;
}
.floatlft {
  float: left;
}
.floatrig {
  float: right;
}
img {
  cursor: pointer;
}
.el-row{
  display: block!important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Footer.vue